module.exports = __webpack_public_path__ + "img/d5f7f02.jpg";